// @flow

export const checks = [
    'isOutbrainDisabled',
    'isUserInContributionsAbTest',
    'isUserNotInContributionsAbTest',
    'isUserInEmailAbTest',
    'emailCanRunPreCheck',
    'listCanRun',
    'emailInArticleOutbrainEnabled',
    'hasHighPriorityAdLoaded',
    'hasLowPriorityAdLoaded',
    'hasLowPriorityAdNotLoaded',
    'isStoryQuestionsOnPage',
    'isJTBDSurveyOnPage',
    'isOutbrainBlockedByAds',
    'isOutbrainMerchandiseCompliant',
    'isOutbrainMerchandiseCompliantOrBlockedByAds',
    'emailCanRun',
    'isUserInEmailAbTestAndEmailCanRun',
    'emailCanRunPostCheck',
];



// WEBPACK FOOTER //
// ./static/src/javascripts/projects/common/modules/check-mediator-checks.js